import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LeverageEventsImage from './LeverageEventsImage'

const copy = {
  heading: `Leverage events, not pageviews`,
  description: `Build a Segment Destination to receive high-intent data from every customer touch point in real-time — abstracting away integration code and sending you structured data in the format you accept.`,
}

const link = {
  text: `Learn more in docs`,
  url: `https://segment.com/docs/partners/`,
}

const LeverageEvents: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBase variant="2Col" copyVariant="narrow" reverse={true}>
        <Section.Copy alignSelf="center">
          <CopyTextBase>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
            <ButtonText size="medium" tag="a" href={link.url} iconEnd={ChevronRightIcon}>
              {link.text}
            </ButtonText>
          </CopyTextBase>
        </Section.Copy>

        <Section.Contents>
          <LeverageEventsImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  ${Section.Wrapper} {
  }
`

export default LeverageEvents
